import { Component, OnInit, Input, ViewChild, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class DatePickerComponent extends BaseFormComponent implements OnInit {
  @Input() maxLength?: number;
  @Input() minDate?: Date; // Earliest date allowed to enter
  @Input() maxDate?: Date; // Latest date allowed to enter
  @Input() FIELD_SPACING: number;
  @Output() userInput? = new EventEmitter<any>();

  isOpen = false;

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  ngOnInit() {
    super.ngOnInit();
    if ( this.maxLength == null ) {
      this.maxLength = 10; // Default field length
    }
  }

  /* Fixing date field dissapearing due to IE11 fix */
  emptyDateInput(event: any) {
    if ( this.formGroup.get(this.propertyName).value == null ) {
      this.formGroup.get(this.propertyName).setValue('');
    }
    this.userInput.emit(event);
  }

}
